module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACPSURBVHgBxZEBCYAwEEVvYgAj2GBGsYE2sMJMYgQjuAhGMIIN5j84ReY2QQU/fG7c3dvgj+hrOedquInN8wSrEzPK6KF+AhFCCxfigeu+IL1RasmhHSDE6Wml1Iq6wBNciPk8y6yEOwYuqWKhx618NNIy3PP3gt9xgikERcEUEAIrvKIoLe2DFq7Fd7L0RhvHUzynU+xw2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ss1.png
// module id = wUcN
// module chunks = 1